<template>
    <v-dialog v-model="show" :width="size" persistent>
        <v-card>
            <slot></slot>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'DialogComponent',
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            size: {
                type: [String, Number],
                default: 'auto',
            },
        },
        computed: {
            show: {
                get () {
                    return this.value
                },
                set (value) {
                    this.$emit('input', value)
                }
            }
        }
    }

</script>
<style scoped>

</style>
